import { render, staticRenderFns } from "./TableFieldCurrencyInput.vue?vue&type=template&id=44053fa6"
import script from "./TableFieldCurrencyInput.vue?vue&type=script&lang=js"
export * from "./TableFieldCurrencyInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports